// extracted by mini-css-extract-plugin
export var infoRow = "_ui-2";
export var labelContainer = "_ui-0";
export var rightInfo = "_ui-1";